<template>
  <div>
    <div class="tabs hide-small">
      <div :class="[ tab === 'main' ? 'active' : '' ]" @click="tab = 'main'">Main details</div>
    </div>
    <div class="tabs tabs-right hide-small">
      <div :class="[ isValid ? 'valid' : 'disabled', 'save-tab' ]" @click="save(false)">{{ saveOrUpdate }}</div>
      <div :class="[ isValid ? 'valid' : 'disabled', 'save-tab' ]" @click="save(true)">{{ saveOrUpdate }} &amp; exit</div>
    </div>
    <div class="dropdown show-small dropdown-admin-tabs">
      <button class="btn dropdown-toggle" type="button" data-toggle="dropdown">Options
        <span class="caret" /></button>
      <ul class="dropdown-menu">
        <li @click="tab = 'main'">
          <a href="#">
            Main details
            <i class="fa fa-check-square-o" v-if="tab === 'main'" />
          </a>
        </li>
        <li :class="[ isValid ? 'valid' : 'disabled', 'save-dropdown' ]" @click="save(false)"><a href="#">{{ saveOrUpdate }}</a></li>
        <li :class="[ isValid ? 'valid' : 'disabled', 'save-dropdown' ]" @click="save(true)"><a href="#">{{ saveOrUpdate }} &amp; exit</a></li>
      </ul>
    </div>
    <section id="main-content" class="clearfix">
      <div class="clearfix" slot="admin-content" id="location-content">
        <div v-if="tab === 'main'">
          <div class="row">
            <div class="col-xs-12 col-sm-6 main-location-details left top-small">
              <div class="form-group">
                <label for="calc-name" class="form-label">Description *</label>
                <input type="text" class="form-control" id="calc-name" v-model="entity.description"/>
              </div>
              <div class="form-group">
                <label class="form-label">Owner</label>
                <auto-complete
                        :dataset="partySearchResults"
                        title="Owner"
                        placeHolder="Type to search"
                        :initVal="entity.owner"
                        v-on:changing="data => partySearchText = data"
                        :fnFormatText="displayParty"
                        :fnSelectValue="displayParty"
                        v-on:selection-made="selectOwner"
                />
              </div>
              <div class="form-group">
                <label class="form-label">Pre Carriage Location</label>
                <auto-complete
                        :dataset="locationSearchResults"
                        title="Pre Carriage Location"
                        placeHolder="Type to search"
                        :initVal="entity.preCarriageLocation"
                        v-on:changing="data => locationSearchText = data"
                        :fnFormatText="displayLocation"
                        :fnSelectValue="displayLocation"
                        v-on:selection-made="l => selectLocation(l, 'preCarriageLocation')"
                ></auto-complete>
              </div>
              <div class="form-group">
                <label for="precarriage-country" class="form-label">Pre Carriage Country</label>
                <select class="form-control" id="precarriage-country" v-model="entity.preCarriageCountry">
                  <option value=""></option>
                  <option v-for="(opt, i) in countries" :value="opt.id">{{ opt.name }}</option>
                </select>
              </div>
              <div class="form-group">
                <label class="form-label">Origin Location</label>
                <auto-complete
                        :dataset="locationSearchResults"
                        title="Origin Location"
                        placeHolder="Type to search"
                        :initVal="entity.originLocation"
                        v-on:changing="data => locationSearchText = data"
                        :fnFormatText="displayLocation"
                        :fnSelectValue="displayLocation"
                        v-on:selection-made="l => selectLocation(l, 'originLocation')"
                />
              </div>
              <div class="form-group">
                <label for="origin-country" class="form-label">Origin Country</label>
                <select class="form-control" id="origin-country" v-model="entity.originCountry">
                  <option value=""></option>
                  <option v-for="(opt, i) in countries" :value="opt.id">{{ opt.name }}</option>
                </select>
              </div>
              <div class="form-group">
                <label class="form-label">Destination Location</label>
                <auto-complete
                        :dataset="locationSearchResults"
                        title="Destination Location"
                        placeHolder="Type to search"
                        :initVal="entity.destinationLocation"
                        v-on:changing="data => locationSearchText = data"
                        :fnFormatText="displayLocation"
                        :fnSelectValue="displayLocation"
                        v-on:selection-made="l => selectLocation(l, 'destinationLocation')"
                />
              </div>
              <div class="form-group">
                <label for="dest-country" class="form-label">Destination Country</label>
                <select class="form-control" id="dest-country" v-model="entity.destinationCountry">
                  <option value=""></option>
                  <option v-for="(opt, i) in countries" :value="opt.id">{{ opt.name }}</option>
                </select>
              </div>
              <div class="form-group">
                <label class="form-label">On Carriage Location</label>
                <auto-complete
                        :dataset="locationSearchResults"
                        title="On Carriage Location"
                        placeHolder="Type to search"
                        :initVal="entity.onCarriageLocation"
                        v-on:changing="data => locationSearchText = data"
                        :fnFormatText="displayLocation"
                        :fnSelectValue="displayLocation"
                        v-on:selection-made="o => selectLocation(o, 'onCarriageLocation')"
                ></auto-complete>
              </div>
              <div class="form-group">
                <label for="oncarriage-country" class="form-label">On Carriage Country</label>
                <select class="form-control" id="oncarriage-country" v-model="entity.onCarriageCountry">
                  <option value=""></option>
                  <option v-for="(opt, i) in countries" :value="opt.id">{{ opt.name }}</option>
                </select>
              </div>
              <div class="form-group">
                <label for="lookup-type" class="form-label">Lookup Type</label>
                <select class="form-control" id="lookup-type" v-model="entity.lookupType">
                  <option value="" />
                  <option v-for="(opt, i) in lookupTypes" :value="opt.id">{{ opt.name }}</option>
                </select>
              </div>
              <div class="form-group">
                <label for="service" class="form-label">Service</label>
                <select class="form-control" id="service" v-model="entity.serviceClass">
                  <option value="" />
                  <option v-for="(opt, i) in serviceTypes" :value="opt.id">{{ opt.name }}</option>
                </select>
              </div>
              <div class="form-group">
                <label for="mode" class="form-label">Mode</label>
                <select v-model="entity.mode" class="form-control" id="mode">
                  <option value=""></option>
                  <option v-for="(opt, i) in modes" :value="opt.id">{{ opt.name }}</option>
                </select>
              </div>
              <div class="form-group">
                <label for="ct" class="form-label">Container Type</label>
                <select v-model="entity.containerType" class="form-control" id="ct">
                  <option value=""></option>
                  <option v-for="(opt, i) in containerTypes" :value="opt.id">{{ opt.name }}</option>
                </select>
              </div>
              <div class="form-group">
                <label for="category" class="form-label">Category *</label>
                <select class="form-control" id="category" v-model="entity.category">
                  <option value="" />
                  <option v-for="(opt, i) in categories" :value="opt">{{ opt }}</option>
                </select>
              </div>
              <div class="form-group">
                <label for="date-from" class="form-label">Effective From</label>
                <input id="date-from" class="mai-date" type="date" v-model="entity.effectiveFrom"/>
              </div>
              <div class="form-group">
                <label for="date-to" class="form-label">Effective To</label>
                <input id="date-to" class="mai-date" type="date" v-model="entity.effectiveTo"/>
              </div>
              <div class="form-group">
                <label for="calc-tu" class="form-label">Brand</label>
                <select class="form-control" id="calc-tu" v-model="entity.brand">
                  <option value="" />
                  <option v-for="(opt, i) in brands" :value="opt.id">{{ opt.name }}</option>
                </select>
              </div>
              <div class="form-group">
                <label for="min-bp" class="form-label">Minimum Breakpoint</label>
                <input id="min-bp" class="mai-date" type="number" v-model="entity.minimumBreakpoint"/>
              </div>
              <div class="form-group">
                <label for="max-bp" class="form-label">Maximum Breakpoint</label>
                <input id="max-bp" class="mai-date" type="number" v-model="entity.maximumBreakpoint"/>
              </div>
            </div>
            <div class="col-xs-12 col-sm-6 main-location-details left bottom-small">
              <div class="form-group">
                <label for="acc-fc" class="form-label">Financial Code</label>
                <select v-model="entity.financialCode" class="form-control" id="acc-fc">
                  <option value=""></option>
                  <option v-for="option in financialCodes" :value="option.id">{{ option.name }}</option>
                </select>
              </div>
              <div class="form-group">
                <label for="rate" class="form-label">Rate *</label>
                <input class="form-control" id="rate" v-model="entity.rate" />
              </div>
              <div class="form-group">
                <label for="rate-currency" class="form-label">Rate Currency *</label>
                <select class="form-control" id="rate-currency" v-model="entity.rateCurrency">
                  <option value=""></option>
                  <option v-for="(opt, i) in currencies" :value="opt.id">{{ opt.name }}</option>
                </select>
              </div>
              <div class="form-group">
                <label for="rates-per" class="form-label">Rates Per *</label>
                <select class="form-control" id="rates-per" v-model="entity.ratesPer">
                  <option value=""></option>
                  <option v-for="(opt, i) in breakpointUnits" :value="opt.id">{{ opt.name }}</option>
                </select>
              </div>
              <div class="form-group">
                <label for="rates-per-name" class="form-label">Rates Per Name</label>
                <input class="form-control" id="rates-per-name" v-model="entity.ratesPerName" />
              </div>
              <div class="form-group">
                <label for="minimum-charge" class="form-label">Minimum {{ category }}</label>
                <input class="form-control" id="minimum-charge" v-model="entity.minimumCost" />
              </div>
              <div class="form-group">
                <label for="advice" class="form-label">Advice only?</label>
                <div class="material-switch">
                  <input id="advice" type="checkbox" v-model="entity.adviceOnly"/>
                  <label for="advice" class="label-success"></label>
                </div>
              </div>
              <div class="form-group">
                <label for="suspended" class="form-label">Suspended?</label>
                <div class="material-switch">
                  <input id="suspended" type="checkbox" v-model="entity.suspended"/>
                  <label for="suspended" class="label-success"></label>
                </div>
              </div>
              <div class="form-group">
                <label for="note" class="form-label">Note</label>
                <textarea class="form-control" rows="5" id="Note" v-model="entity.note" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>
<script>
  import AdminEntityMixin from '../../mixins/AdminEntityMixin'
  import HelperMixin from '../../mixins/Helpers'
  import AutoComplete from '../../../helpers/AutoComplete.vue'
  export default {
    name: 'Accessorial',
    mixins: [AdminEntityMixin, HelperMixin],
    components: {
      AutoComplete
    },
    data () {
      return {
        transformForUpdate: {
          brand: this.toMinus,
          preCarriageCountry: this.toMinus,
          originCountry: this.toMinus,
          destinationCountry: this.toMinus,
          onCarriageCountry: this.toMinus,
          lookupType: this.toMinus,
          serviceClass: this.toMinus,
          mode: this.toMinus,
          containerType: this.toMinus,
          ratesPer: this.toMinus,
          category: this.toMinus,
          financialCode: this.toMinus,
          effectiveFrom: this.toDateOrNull,
          effectiveTo: this.toDateOrNull
        },
        newEntityScreen: 'Admin - Accessorials',
        editEntityScreen: 'Admin - Edit/View Accessorial',
        boxes: [
          {
            prop: 'brand',
            id: 'id'
          },
          {
            prop: 'rateCurrency',
            id: 'id'
          },
          {
            prop: 'ratesPer',
            id: 'id'
          },
          {
            prop: 'lookupType',
            id: 'id'
          },
          {
            prop: 'serviceClass',
            id: 'id'
          },
          {
            prop: 'preCarriageCountry',
            id: 'id'
          },
          {
            prop: 'originCountry',
            id: 'id'
          },
          {
            prop: 'destinationCountry',
            id: 'id'
          },
          {
            prop: 'onCarriageCountry',
            id: 'id'
          },
          {
            prop: 'mode',
            id: 'id'
          },
          {
            prop: 'containerType',
            id: 'id'
          },
          {
            prop: 'financialCode',
            id: 'id'
          }
        ],
        tab: 'main',
        entityName: 'accessorial',
        entity: {
          id: null,
          description: null,
          financialCode: null,
          adviceOnly: null,
          category: null,
          effectiveFrom: null,
          effectiveTo: null,
          accessorialType: null,
          brand: null,
          preCarriageLocation: null,
          preCarriageCountry: null,
          originLocation: null,
          originCountry: null,
          destinationLocation: null,
          destinationCountry: null,
          onCarriageLocation: null,
          onCarriageCountry: null,
          owner: null,
          rate: null,
          rateCurrency: null,
          ratesPer: null,
          ratesPerName: null,
          minimumCost: null,
          lookupType: null,
          serviceClass: null,
          mode: null,
          containerType: null,
          minimumBreakpoint: null,
          maximumBreakpoint: null,
          note: null
        },
        brand: '',
        onLoadTransformations: {
          effectiveFrom: this.fromTimestamp,
          effectiveTo: this.fromTimestamp
        },
        effectiveTo: {
          time: window.getYMDDate()
        },
        effectiveFrom: {
          time: window.getYMDDate()
        }
      }
    },
    watch: {
      'effectiveTo.time' (newVal, oldVal) {
        if (this.entity.effectiveTo !== newVal) {
          this.entity.effectiveTo = newVal
        }
      },
      'effectiveFrom.time' (newVal, oldVal) {
        if (this.entity.effectiveFrom !== newVal) {
          this.entity.effectiveFrom = newVal
        }
      },
      'entity.effectiveFrom' (newVal, oldVal) {
        if (this.effectiveFrom.time !== newVal) {
          this.effectiveFrom.time = newVal
        }
      },
      'entity.effectiveTo' (newVal, oldVal) {
        if (this.effectiveTo.time !== newVal) {
          this.effectiveTo.time = newVal
        }
      }
    },
    computed: {
      isValid () {
        return this.entity.description &&
          this.entity.category &&
          this.entity.rate &&
          this.entity.rateCurrency &&
          this.entity.ratesPer
      },
      brands () {
        return this.filterOptions('BRAND')
      },
      breakpointUnits () {
        return this.filterOptions('BREAKPOINT_UNIT')
      },
      modes () {
        return this.filterOptions('MODE')
      },
      lookupTypes () {
        return this.filterOptions('LOOKUP_TYPE')
      },
      containerTypes () {
        return this.filterOptions('CONTAINER_TYPE')
      },
      categories () {
        return ['COST', 'CHARGE']
      },
      serviceTypes () {
        return this.$store.getters['systemOption/serviceTypes']
      },
      countries () {
        return this.$store.getters['systemOption/countries']
      },
      category () {
        return this.entity.category === 'CHARGE' ? 'Charge' : 'Cost'
      },
      financialCodes () {
        return this.$store.getters['systemOption/financialCodes'].sort((a, b) => {
          return a.name < b.name ? -1 : a.name > b.name ? 1 : 0
        })
      }
    },
    methods: {
      displayParty (p) {
        let str = `${p.name}, ${p.code}`
        if (p.address !== null) {
          if (p.address.subdivision) {
            str += `, ${p.address.subdivision}`
          }
          if (p.address.country !== null) {
            str += `, ${p.address.country.code}`
          }
        }
        return str
      },
      selectOwner (o) {
        this.entity.owner = o
        this.partySearchText = ''
        this.partySearchResults = []
      },
      selectLocation (location, prop) {
        this.locationSearchText = ''
        this.locationSearchResults = []
        this.entity[prop] = location
      },
      filterOptions (code) {
        return this.systemOptions.filter(({optionType}) => optionType !== null && optionType.hasOwnProperty('code') && optionType.code === code)
      },
      getBaseData () {
        return {
          id: null,
          description: null,
          financialCode: null,
          adviceOnly: null,
          category: null,
          effectiveFrom: null,
          effectiveTo: null,
          accessorialType: null,
          brand: null,
          preCarriageLocation: null,
          preCarriageCountry: null,
          originLocation: null,
          originCountry: null,
          destinationLocation: null,
          destinationCountry: null,
          onCarriageLocation: null,
          onCarriageCountry: null,
          owner: null,
          rate: null,
          rateCurrency: null,
          ratesPer: null,
          ratesPerName: null,
          minimumCost: null,
          lookupType: null,
          serviceClass: null,
          mode: null,
          containerType: null,
          minimumBreakpoint: null,
          maximumBreakpoint: null,
          note: null
        }
      },
      updateEntity (prop, method, val) {
        this.entity[prop] = this[method](val)
      }
    }
  }
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/modules/admin/components/Accessorial/Accessorial.vue